import { render, staticRenderFns } from "./outage-warning-notifier.vue?vue&type=template&id=6a04b48c&"
import script from "./outage-warning-notifier.vue?vue&type=script&lang=js&"
export * from "./outage-warning-notifier.vue?vue&type=script&lang=js&"
import style0 from "./outage-warning-notifier.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports